import { NgModule } from '@angular/core';
import { VideoTextComponent } from './video-text.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        VideoTextComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        VideoTextComponent
    ]
})
export class NcVideoTextModule { }